"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const location_component_item_1 = __importDefault(require("./location-component-item"));
const availability_status_1 = require("../../utils/availability-status");
const styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
const LocationComponent = ({ city, locations, availability, holidays, availabilityErr }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h4", Object.assign({ className: styles_module_scss_1.default.cityName }, { children: city }), city), (0, jsx_runtime_1.jsx)("ul", Object.assign({ className: "no-bullet" }, { children: locations.map((l) => {
                    const location = Object.assign(Object.assign({}, l), { availability: availability[l.id] });
                    (0, availability_status_1.getOpenCloseTime)(location, holidays);
                    return (0, jsx_runtime_1.jsx)(location_component_item_1.default, { location: location, availabilityErr: availabilityErr });
                }) }))] }, "holder-" + city));
};
exports.default = LocationComponent;
